import React from "react";
import { Card, Button, Tag, Typography } from "antd";
import { EditOutlined, ShoppingCartOutlined } from "@ant-design/icons";
import { useProductsQuery } from "../../../Services";
import { WebProductsDrawer } from "./WebProductsDrawer";

const { Title, Text } = Typography;

interface WebProductsCardProps {
  onManage: () => void;
  webProductsDrawerOpen: boolean;
  setWebProductsDrawerOpen: (open: boolean) => void;
}

export const WebProductsCard: React.FC<WebProductsCardProps> = ({
  onManage,
  webProductsDrawerOpen,
  setWebProductsDrawerOpen,
}) => {
  const webProductsQuery = useProductsQuery(
    { page: 1, limit: 1, is_on_web: true },
    { staleTime: 60 * 1000 },
  );
  const totalOnWeb = webProductsQuery.data?.total ?? 0;

  return (
    <Card
      className="!rounded-lg hover:shadow-md transition-all duration-200 !border-gray-200"
      styles={{ body: { padding: 0 } }}
    >
      <div className="p-5">
        <div className="flex items-start justify-between mb-3">
          <div className="flex items-center gap-3 min-w-0 flex-1">
            <div className="w-10 h-10 rounded-lg flex items-center justify-center text-lg shrink-0 bg-[#1677ff15] text-[#1677ff]">
              <ShoppingCartOutlined />
            </div>
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-2">
                <Title
                  level={5}
                  className="!mb-0 !text-sm !font-semibold text-gray-900"
                >
                  Web Products
                </Title>
                <Tag
                  className="!m-0 !text-[10px] !leading-4 !px-1.5 !font-medium !border-0"
                  style={{
                    backgroundColor: "#1677ff15",
                    color: "#1677ff",
                  }}
                >
                  {totalOnWeb} {totalOnWeb === 1 ? "item" : "items"}
                </Tag>
              </div>
              <Text type="secondary" className="text-xs">
                Toggle which products appear on the website
              </Text>
            </div>
          </div>
          <Button
            type="primary"
            size="small"
            icon={<EditOutlined />}
            onClick={onManage}
            className="!min-w-[64px] shrink-0 ml-2"
          >
            Manage
          </Button>
        </div>
      </div>

      <WebProductsDrawer
        open={webProductsDrawerOpen}
        onClose={() => setWebProductsDrawerOpen(false)}
      />
    </Card>
  );
};
